import { GenericData, Catalog, Category, Product, Stage } from ".";

export class AppComponentModel {
  public hasCursus: boolean = false;
  public hasStages: boolean = false;
  public isAdmin: boolean = false;
  public loaded: boolean = false;
  constructor() {
    this.hasCursus = false;
    this.hasStages = false;
    this.isAdmin = false;
    this.loaded = false;
  }
}

export class CatalogComponentModel {
  public catalogs: Array<GenericData<Catalog>>;
  public selectedCatalog: Catalog | null;
  constructor() {
    this.catalogs = [];
    this.selectedCatalog = null;
  }
}

export class CategoryComponentModel {
  public categories: Array<GenericData<Category>>;
  public parentCatalog: Catalog | null;
  public selectedCategory: Category | null;
  constructor() {
    this.categories = [];
    this.parentCatalog = null;
    this.selectedCategory = null;
  }
}

export class ProductComponentModel {
  public productsList: Product[];
  public parentCategory: Category | null;
  public selectedProduct: Product|null;
  public selectedProductStagesList: Stage[];
  public catName: string;
  constructor() {
    this.productsList = [];
    this.parentCategory = null;
    this.selectedProduct = null;
    this.selectedProductStagesList = [];
    this.catName = '';
  }
}
